import styled from "styled-components";

export const RestorationContainer = styled.div`
  color: #091427;
  height: 100%;
  width: 77rem;
  margin: 60px auto 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 1000px) {
    max-width: 100%;
    margin: 0 auto 50px auto;
  }

`
export const HeaderCentered = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    @media screen and (max-width: 1000px) {
      font-size: 1.714285rem;
      text-align: center;
      margin-top: 50px;
    }
  }
`